// src/axiosPlugin.mjs
import axiosInstance from "./axiosInstance";

export default {
	install: (app: any) => {
		app.config.globalProperties.$axios = axiosInstance;

		// Interceptor per debug degli errori
		// axiosInstance.interceptors.response.use(
		//   (response) => response, // Restituisci la risposta se è valida
		//   (error) => {
		//     console.error("Errore Axios:", error.response || error.message); // Log degli errori
		//     return Promise.reject(error); // Propaga l'errore
		//   }
		// );
	},
};
